import { useCallback } from 'react';
import useAskLocation from '@/hooks/useAskLocation';
import { useAppDispatch } from '@/utils/redux';
import { askQuestion } from '@/utils/slices/askSlice';

/**
 * Submits an Ask AllTrails question, searching the part of the map the user can see unless the question names a place.
 */
const useAskQuestion = () => {
  const dispatch = useAppDispatch();
  const getAskLocation = useAskLocation();

  return useCallback(
    (question: string) => {
      dispatch(askQuestion({ location: getAskLocation(), question }));
    },
    [dispatch, getAskLocation]
  );
};

export default useAskQuestion;
